<template>
  <div v-if="authenticated">
    <v-app-bar
      v-if="authenticated"
      permanent
      app
      :color="$vuetify.theme.dark ? 'light' : 'white'"
      flat
      clipped-left
    >
      <v-app-bar-nav-icon
        @click.stop="drawerIsMini = !drawerIsMini"
      ></v-app-bar-nav-icon>
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-3 grey--text"
        :id="authenticatedUser.shop && authenticatedUser.shop.id"
      >
        <v-menu
          v-if="
            authenticatedUser &&
            authenticatedUser.shops &&
            authenticatedUser.shops.length > 1
          "
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ on }">
            <v-btn x-small icon class="ml-1" v-on="on">
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-card :loading="isFetching" :disabled="isFetching">
            <v-list>
              <v-list-item
                v-for="shop in authenticatedUser.shops"
                :key="shop.id"
              >
                <v-list-item-avatar>
                  <v-icon
                    :key="shop.id"
                    v-if="authenticatedUser.active_shop_id !== shop.id"
                    x-small
                    >fa-store-alt</v-icon
                  >
                  <v-icon v-else x-small>$check</v-icon>
                </v-list-item-avatar>
                <v-list-item-title
                  @click="changeActiveShop(shop)"
                  :class="{
                    pointer: authenticatedUser.active_shop_id !== shop.id,
                    'grey--text': authenticatedUser.active_shop_id !== shop.id,
                  }"
                >
                  {{ shop.legal_name }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
        {{ authenticatedUser.shop && authenticatedUser.shop.legal_name }}
      </v-toolbar-title>
      <global-search v-if="isShopActive" class="hidden-sm-and-down" />
      <v-spacer></v-spacer>
      <v-btn
          v-if="$i18n.locale==='ru' && isShopActive"
          color="primary"
          icon
          target="_blank"
          href="https://t.me/levam_platforma"
          :title="$t('viewHome.our_chat') +': '+ $t('viewHome.follow')"
      >
        <v-icon>$telegram</v-icon>
      </v-btn>
      <help-system-component v-if="isShopActive" @show="showHelpTour"/>
      <v-btn
        v-if="isShopActive"
        href="//mechanic.levam.net"
        icon
        :title="$t('common.mechanic_dashboard')"
        target="_blank"
        class="mr-1"
      >
        <v-icon>fa-cogs</v-icon>
      </v-btn>
      <cart-button-component v-if="isShopActive"/>

      <v-btn
        icon
        @click="logout"
        :title="$t('common.logout_from_account') + ' ' + authenticatedUser.name"
        class="mr-1"
      >
        <v-icon>$logout</v-icon>
      </v-btn>
    </v-app-bar>
    <navigation-drawer-component
      :mini="drawerIsMini"
      @showSupportMessage="showSupportMessage"
    ></navigation-drawer-component>
    <new-call-notify />
    <v-tour
      name="helpTour"
      :steps="helpsteps"
      :options="helpOptions"
    ></v-tour>

    <levam-support-window
      :borderRadius="`10px`"
      :ticketId="ticketId"
      :isVisible.sync="isShowSupportMessageWindow"
      :lang="levamSupportWindowLang"
      :isDarkTheme="$vuetify.theme.dark"
      :backendURL="url"
    >
    </levam-support-window>
  </div>
</template>

<script>
import { mapState } from "vuex";

import NavigationDrawerComponent from "@/components/common/NavigationDrawerComponent";
import RightsMixin from "@/mixins/rights";
import NewCallNotify from "@/components/common/NewCallNotify";
import { mapFields } from "vuex-map-fields";
import GlobalSearch from "@/components/common/GlobalSearch";
import HelpSystemComponent from "@/components/common/HelpSystemComponent";
import CartButtonComponent from "@/components/common/CartButtonComponent";

export default {
  mixins: [RightsMixin],
  name: "TopBarComponent",
  components: {
    CartButtonComponent,
    HelpSystemComponent,
    GlobalSearch,
    NewCallNotify,
    NavigationDrawerComponent,
  },
  data: () => ({
    drawerIsMini: true,
    drawer: false,
    ticketId: null,
    isShowSupportMessageWindow: false,
  }),
  created() {
    let ticketId = window.location.href.split("show_support_ticket=")[1];
    if (parseInt(ticketId) > 0) {
      this.ticketId = parseInt(ticketId);
      this.isShowSupportMessageWindow = true;
    }
  },

  watch: {
    isShowSupportMessageWindow() {
      if (!this.isShowSupportMessageWindow) {
        let url = window.location.href.split("show_support_ticket=");
        window.location.href = url[0];
      }
    },

  },
  computed: {
    isShopActive(){
      return this.authenticatedUser && this.authenticatedUser.shop && this.authenticatedUser.shop.is_active;
    },
    ...mapState("auth", ["authenticated", "authenticatedUser", "isFetching"]),
    ...mapState("site", ["siteTitle"]),
    ...mapFields("helptour", ["helpsteps"]),
    levamSupportWindowLang(){
      switch(this.$i18n.locale){
        case 'ru':
        case 'en':
        case 'es':
          return this.$i18n.locale;
        default:
          return 'en';
      }
    },
    url() {
      return process.env.VUE_APP_API_URL;
    },
    helpOptions() {
      return {
        startTimeout: 500,
        labels: {
          buttonSkip:this.$t("common.finish"),
          //buttonPrevious: this.$t("common.previous"),
          buttonNext: this.$t("common.next"),
          buttonStop:  this.$t("common.finish"),
        },
        enabledButtons: {
          buttonSkip: true,
          buttonPrevious: false,
          //buttonPrevious: true,
          buttonNext: true,
          buttonStop: true
        },
      };
    },
  },
  methods: {
    showSupportMessage() {
      this.isShowSupportMessageWindow = true;
    },
    changeActiveShop(shop) {
      if (shop.id === this.authenticatedUser.active_shop_id) return;
      this.$store.dispatch("auth/changeActiveShop", shop.id).then(() => {
        document.location.reload();
      });
    },
    showHelpTour() {
      this.$tours["helpTour"].start();
    },
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
  },
};
</script>
